import { useEffect, useState } from "react";
import CommentAvatarHeader from "./comment-avatar-header";
import CommentCard from "./comment-card";
import styleSheet from "./style.module.scss";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
type Props = {
  commentData: any;
  comment:any
};

const Comments = (props: Props) => {
  const { commentData ,comment} = props;
  const [comments, setComments] = useState<any>({});
  const [commentKey, setCommentKey] = useState<any>([]);
  const { t } = useTranslation();

  const setCommentData = (data: any) => {
    const comment = data.data;
    setComments(comment);
    if (comment && typeof comment === "object") {
      const keys = Object.keys(comment).reverse();
      setCommentKey(keys);
    }
  };

  const getTime = (time: any) => {
    return `${dayjs(time).format("HH:mm")} Uhr`;
  };
  useEffect(() => {
    setCommentData(commentData);
  }, [commentData]);

  return (
    <>
      <div className="my-2">
        {commentKey?.map((key: any) => {
          return (
            <>
              <div
                className={`d-flex flex-wrap justify-content-center ${styleSheet.comment_div}  `}
              >
                <p
                  className={`small-font ${styleSheet.date_chip} mohave-bold text-white rounded-pill px-2 mb-0 translate-middle-y`}
                >
                  {key}
                </p>
              </div>
              {comments[key]?.map((data: any) => {
                return (
                  <div className="px-3 pb-2">
                    <div className="">
                      <CommentAvatarHeader
                        name={data.usr_name}
                        img={data.usr_pic}
                        agoTime={getTime(data.created_at)}
                        from={data.from?.pro_name?data.from?.pro_name:data.from?.orb_name}
                        fromImage ={data.from.cat_image_url?data.from.cat_image_url:null}
                      />
                    </div>
                    <div className="ps-5 pb-2">
                      <CommentCard comment={data?.dis_discussion} />
                    </div>
                  </div>
                );
              })}
            </>
          );
        })}
        {!commentKey.length && (
            <div className=" position-absolute top-50 start-50 translate-middle  mohave text-white  ">
            <p className="">{t("no_data_found")}</p>
          </div>
        )}
      </div>
    </>
  );
};

export default Comments;
